import React, { useRef, useCallback } from "react";
import PropTypes from "prop-types";
import DynamicComponent from "@/components/DynamicComponent";
import DesktopNavbar from "./DesktopNavbar";
import MobileNavbar from "./MobileNavbar";
import { useTheme } from "@/components/ThemeProvider";

import "./index.less";

export default function ApplicationLayout({ children }) {
  const mobileNavbarContainerRef = useRef();
  const getMobileNavbarPopupContainer = useCallback(() => mobileNavbarContainerRef.current, []);
  const { isDarkMode } = useTheme();

  return (
    <React.Fragment>
        <DynamicComponent name="ApplicationWrapper">
        <div className={`application-layout-side-menu ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
            <DynamicComponent name="ApplicationDesktopNavbar">
              <DesktopNavbar />
            </DynamicComponent>
          </div>
          <div className={`application-layout-content ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
            <nav className="application-layout-top-menu" ref={mobileNavbarContainerRef}>
              <DynamicComponent name="ApplicationMobileNavbar" getPopupContainer={getMobileNavbarPopupContainer}>
                <MobileNavbar getPopupContainer={getMobileNavbarPopupContainer} />
              </DynamicComponent>
            </nav>
            {children}
          </div>
        </DynamicComponent>
    </React.Fragment>
  );
}

ApplicationLayout.propTypes = {
  children: PropTypes.node,
};

ApplicationLayout.defaultProps = {
  children: null,
};
